import { render } from "./InActiveHospitals.vue?vue&type=template&id=43b7f5ce"
import script from "./InActiveHospitals.vue?vue&type=script&lang=js"
export * from "./InActiveHospitals.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/hospitals/InActiveHospitals.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43b7f5ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43b7f5ce', __exports__)) {
    console.log('reload')
    api.reload('43b7f5ce', __exports__)
  }
  
  module.hot.accept("./InActiveHospitals.vue?vue&type=template&id=43b7f5ce", () => {
    console.log('re-render')
    api.rerender('43b7f5ce', render)
  })

}


export default __exports__